import {
	SET_FOOD_MENU,
	UPDATE_FOOD_QUANTITY,
	RESET_MENU,
	SET_TRANSACTIONS,
} from './actionTypes';

const initialState = {
	foodItems: {},
	foodList: {},
	restaurantList:[],
	list: null,
	sideList: null,
	failedTransactions: null,
};

export default (state = initialState, { type, payload }) => {
	switch (type) {
		case SET_FOOD_MENU: {
			return {
				...state,
				...payload,
			};
		}
		case UPDATE_FOOD_QUANTITY: {
			const { foodItemId, quantity } = payload;
			return {
				...state,
				foodItems: {
					...state.foodItems,
					[foodItemId]: {
						...state.foodItems[foodItemId],
						quantity,
					},
				},
			};
		}
		case SET_TRANSACTIONS: {
			return {
				...state,
				failedTransactions: payload,
			};
		}
		case RESET_MENU:
			return initialState;
		default:
			return state;
	}
};
